import React from 'react';
import { createUseStyles } from 'react-jss';
import { Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles({
  indicator: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: '#fff7ed !important',
    marginLeft: 6,
    cursor: 'default',
    verticalAlign: 'middle',
  },
  icon: {
    fontSize: 10,
    color: '#fb923c !important',
  },
  tooltipLabel: {
    color: '#fb923c',
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  tooltipValue: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 500,
  },
});

interface CrossVendorIndicatorProps {
  masterVendorName: string;
}

const CrossVendorIndicator: React.FC<CrossVendorIndicatorProps> = ({ masterVendorName }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Tooltip
      title={
        <>
          <div className={classes.tooltipLabel}>{t('Master Vendor')}</div>
          <div className={classes.tooltipValue}>{masterVendorName}</div>
        </>
      }
      overlayInnerStyle={{ background: '#1a1a2e' }}
    >
      <span className={classes.indicator}>
        <SwapOutlined className={classes.icon} />
      </span>
    </Tooltip>
  );
};

export default CrossVendorIndicator;
